export default "__VITE_ASSET__DZymFx2K__"